// @flow
//
// Forked from date_input.js
// The <MaskInput /> component provides input masking functionality
// for formatted text input fields.
//
// This component applies a specified mask pattern to user input,
// ensuring data is entered in the correct format (e.g., bill id,
// phone numbers, credit cards, etc.)
//
// The component accepts a mask string that defines the input pattern,
// and handles the formatting automatically through the Inputmask library.
//
// Styling: You can pass in a class name as the className prop, which
// is applied to the top-level div. The component includes label
// and input wrapper elements that can be styled via CSS.
//
// Note: This component uses the Inputmask library to handle the
// masking behavior.

import { Component } from "react";
import * as React from "react";
import Inputmask from "inputmask";

type Props = {
    onChange: (string) => void,
    error: boolean,
    labelText: string,
    placeholder: string,
    className?: string,
    initialValue?: string,
    mask: string,
    name: string,
};

type State = {
    lastValue: ?string,
};

class MaskInput extends Component<Props, State> {
    inputElement: any;
    handleChange: (SyntheticInputEvent<HTMLInputElement>) => string;

    constructor() {
        super();
        this.inputElement = React.createRef();
        this.state = {
            lastValue: null,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e: SyntheticInputEvent<HTMLInputElement>): string {
        const newVal = e.target.value;

        if (newVal !== this.state.lastValue) {
            if (newVal !== null && this.props.onChange) {
                this.props.onChange(newVal);
            }

            let updates = {
                lastValue: newVal,
            };
            this.setState(updates);
        }
        return newVal;
    }

    componentDidUpdate() {
        if (this.props.initialValue && this.state.lastValue === null) {
            this.setState({ lastValue: this.props.initialValue });
        }
    }

    componentDidMount() {
        if (this.inputElement.current) {
            Inputmask(this.props.mask, {
                placeholder: " ",
                greedy: false,
                jitMasking: true,
                showMaskOnFocus: false,
                showMaskOnHover: false,
            }).mask(this.inputElement.current);
        }

        if (this.props.initialValue && this.state.lastValue === null) {
            this.setState({ lastValue: this.props.initialValue });
        }
    }

    render(): React.Node {
        // Filter and format the displayed date string on change
        const displayValue = this.state.lastValue || "";

        return (
            <div className={this.props.className || ""}>
                <label className="block">
                    {this.props.labelText}
                    <div className="auth-form--input-wrapper">
                        <input
                            ref={this.inputElement}
                            onChange={this.handleChange}
                            placeholder={this.props.placeholder}
                            autoComplete="off"
                            inputMode="numeric"
                            size={20}
                            name={this.props.name}
                        />
                        {this.props.error ? (
                            <img src="/static/media/icons/icon_close_black.svg" />
                        ) : null}
                    </div>
                </label>
            </div>
        );
    }
}
export default MaskInput;
